import React from 'react';

const SettingsSidebar = ({ activeSection, setActiveSection }) => {
  return (
    <div style={{ marginBottom: '32px' }}>
    </div>
  );
};

export default SettingsSidebar;
